import React, { useState } from "react";
import "@styles/pages/MemberZone/MyProducts.scss";
import { Box, Typography, Pagination } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AccordionRow from "@components/ui/AccordionRow";
import dayjs from "dayjs";

const MyProducts = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const isHK = currentLang === "hk";
  const myProductList = useSelector(
    (state) => state.memberMyProduct.myProductList
  );

  const statusLabelMap = {
    0: t("member:status_pending"),
    1: t("member:status_approved"),
    "-1": t("member:status_rejected"),
  };

  const itemsPerPage = 10;
  const [page, setPage] = useState(1);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const paginatedData = myProductList.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const totalPages = Math.ceil(myProductList.length / itemsPerPage);

  return (
    <Box className="my-products-container">
      <Typography className="title">
        <Trans i18nKey="member:my_products" />
      </Typography>

      {paginatedData.length === 0 && (
        <Typography className="no-data-container">
          <Trans i18nKey="member:no_product_found" />
        </Typography>
      )}
      {paginatedData.map((item, index) => (
        <AccordionRow
          key={index}
          summaryTitle={t("member:product_name")}
          summaryValue={item?.product_name}
          summaryRight={`${item?.point_earn.toLocaleString()} S dollar`}
          details={[
            {
              label: t("member:application_date"),
              value: dayjs(item?.registration_date).format("YYYY-MM-DD"),
            },
            { label: t("member:invoice_number"), value: item?.invoice_no },
            { label: t("member:serial_number"), value: item?.serial_no },
            {
              label: t("member:purchase_date"),
              value: dayjs(item?.purchase_date).format("YYYY-MM-DD"),
            },
            {
              label: t("member:status"),
              value: (
                <Box
                  className={
                    "status-label" +
                    " " +
                    (item?.status == -1
                      ? "red-status"
                      : item?.status == 0
                      ? "orange-status"
                      : item?.status == 1
                      ? "green-status"
                      : "")
                  }
                >
                  {statusLabelMap[item?.status]}
                </Box>
              ),
            },
            {
              label: item?.status == -1 && t("member:reason"),
              value:
                item?.status == -1
                  ? isHK
                    ? item?.reject_reason_tc
                    : item?.reject_reason_en
                  : "",
            },
          ]}
        />
      ))}

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default MyProducts;
